import { Avatar, Col, Row } from 'antd'
import Flex from 'components/Flex'
import CallIcon from 'components/icons/CallIcon'
import EditIcon from 'components/icons/EditIcon'
import MailIcon from 'components/icons/MailIcon'
import OfferIcon from 'components/icons/OfferIcon'
import AdditionDrawer from 'modules/Resume/DrawerComponents/AdditionalDetails/AdditionDrawer'
import SocialMediaDrawer from 'modules/Resume/DrawerComponents/AdditionalDetails/SocialMediaDrawer'
import AwardsDrawer from 'modules/Resume/DrawerComponents/AwardDetails/AwardsDrawer'
import EducationalDetailDrawer from 'modules/Resume/DrawerComponents/EducationDetails/EducationalDrawer'
import ObjectiveDrawer from 'modules/Resume/DrawerComponents/ObjectiveDrawer'
import CourseTrainingDrawer from 'modules/Resume/DrawerComponents/ProjectDetails/CourseTraining'
import InternshipDrawer from 'modules/Resume/DrawerComponents/ProjectDetails/InternshipDrawer'
import ProjectDrawer from 'modules/Resume/DrawerComponents/ProjectDetails/ProjectDrawer'
import WorkExperienceDrawer from 'modules/Resume/DrawerComponents/ProjectDetails/WorkExperienceDrawer'
import ProofDocuments from 'modules/Resume/DrawerComponents/ProofDocuments'
import AdditionalInfo from 'modules/Resume/Style/AdditionalInfo'
import AwardsSection from 'modules/Resume/Style/AwardsSection'
import CurrentlyPursuing from 'modules/Resume/Style/CurrentlyPur'
import Documents from 'modules/Resume/Style/Documents'
import EducationSection from 'modules/Resume/Style/EducationSection'
import InternshipSection from 'modules/Resume/Style/InternshipSection'
import ProjectSection from 'modules/Resume/Style/ProjectDetailsSection'
import SocialMediaLinks from 'modules/Resume/Style/SocialMediaLinks'
import ResumeSection from 'modules/Resume/Style/ResumeSection'
import { SetDefaultPill } from 'modules/Resume/Style/ResumeStyle'
import DefaultResumeDrawer from "modules/Resume/DrawerComponents/DefaultResumeDrawer";
import UploadResumeDrawer from "modules/Resume/DrawerComponents/UploadResumeDrawer";
import SuccessMessage from "utils/SuccessMessage"
import { logResumeDownload, singlePdf, resumeBulkDownload } from "modules/Resume/actions";
import {
  CollegeName,
  EditorContent,
  GeneralEditIcon,
  HeaderFlexOne,
  InfoSection,
  LeftCol,
  MainHeading,
  MenuItem,
  OuterDiv,
  RightDiv,
  RowwithPadding,
  SectionNavMenu,
  SectionWrapper,
  StudentName,
  StyledDivider,
  StyledP,
  SubFLex,
  TopHeader,
  TopHeading,
} from 'modules/Resume/Style/style'
import TrainingSection from 'modules/Resume/Style/TrainingSection'
import WorkExpSection from 'modules/Resume/Style/WorkExpSection'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import ResumeDownload from './Components/ResumeDownload'
import AvatarImage from 'components/Avatar'
import Button from 'components/Button'
import instituteRequest from 'utils/instituteRequest'
import './style.css'

const Resume = ({
  getStudentData,
  getPromotion,
  getPendingData,
  getCollege,
  studentDetails,
  promotionData,
  pendingData,
  updateStudentData,
  deleteFile,
  deleteEducation,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  getCities,
  getFunctionsList,
  functionsList,
  getDesignationsList,
  getIndustryList,
  countryList = [],
  stateList = [],
  degreeList,
  getListOfSkills,
  getListOfAllCollegesCurCourse,
  searchAPI,
  getStudentResumeData,
  upsertStudentResume
}) => {
  console.log(studentDetails,'studentDetails')
  useEffect(() => {
    getStudentData()
    getPromotion()
    getPendingData()
    getCollege()
    getListOfCountries()
    getDesignationsList()
    getListOfState()
  }, [])
 const [studentFullData , setStudentFullData] = useState(null)
  const listOfStudentSkills = []
  const instituteName = useSelector(state => state?.studentData?.campusDetails)
const [resumeList,setResumeList] = useState([])
const { JBIMS_INSITITUTE_CAMPUS_ID } = process.env;

  const object = useRef()
  const education = useRef()
  const project = useRef()
  const course = useRef()
  const award = useRef()
  const workexp = useRef()
  const params = useParams()
  const studentId = params.studentId
  const dispatch = useDispatch()

  const [objectiveDrawer, setObjectiveDrawer] = useState(false)
  const [educationDrawer, setEducationDrawer] = useState(false)
  const [projectDrawer, setProjectDrawer] = useState(false)
  const [internDrawer, setInternDrawer] = useState(false)
  const [courseDrawer, setCourseDrawer] = useState(false)
  const [workExperienceDrawer, setWorkExperienceDrawer] = useState(false)
  const [awardsDrawer, setAwardsDrawer] = useState(false)
  const [additionalDrawer, setAdditionalDrawer] = useState(false)
  const [socialDrawer, setSocialDrawer] = useState(false)
  const [proofDrawer, setProofDrawer] = useState(false)
  const [resumeFiles, setResumeFiles] = useState([]);
  const [resumeError, setResumeError] = useState("");
  const [defaultDrawer, setDefaultDrawer] = useState(false);
  const [defaultResumeId, setDefaultResumeId] = useState("PIL")
  const [uploadDrawer, setUploadDrawer] = useState(false);
  const [backendResumes, setBackendResumes] = useState([]);
  const [loadingResumes, setLoadingResumes] = useState(true);
  const ref = useRef()
  const [isResumeFrozen, setIsResumeFrozen] = useState(false)
  const [frozenFields, setFrozenFields] = useState({})

useEffect(() => {
  const fetchResumeFreeze = async () => {
    try {
      const campusId = instituteName?.id
      if (!campusId || !studentDetails) return

      const res = await instituteRequest.get(
        `/institutes/${campusId}/tpo-approval-config`
      )

      const fields = res?.data?.data?.tpoApprovalConfig?.fields || {}
      const cvConfig = fields['cv']

      // 🔑 IMPORTANT: freeze only if rule exists AND resume exists
      const hasResume =
        (resumeFiles && resumeFiles.length > 0) ||
        studentDetails?.student?.cvUrl?.url

      if (
        cvConfig &&
        cvConfig.freezeAfterVerification === true &&
        hasResume
      ) {
        setIsResumeFrozen(true)
      } else {
        setIsResumeFrozen(false)
      }
    } catch (e) {
      console.error('Resume freeze check failed', e)
      setIsResumeFrozen(false)
    }
  }

  fetchResumeFreeze()
}, [instituteName?.id, studentDetails, resumeFiles])

// Calculate education frozenFields like the drawer does
useEffect(() => {
  const calculateEducationFrozenFields = async () => {
    if (!studentDetails || !instituteName?.id) return

    const frozen = {}
    const educationData = studentDetails?.education || []
    
    try {
      const res = await instituteRequest.get(
        `/institutes/${instituteName.id}/tpo-approval-config`
      )
      const fields = res?.data?.data?.tpoApprovalConfig?.fields || {}

      educationData.forEach((edu) => {
        if (!edu.id) return

        const eduId = edu.id
        frozen[eduId] = {}

        let fieldPrefix = ''
        const level = edu.educationLevel?.toLowerCase()
        
        if (level === 'tenth' || level === 'hsc') {
          fieldPrefix = 'tenth'
        } else if (level === 'twelfth' || level === 'sslc' || level === 'puc') {
          fieldPrefix = 'twelfth'
        } else if (level?.startsWith('ug') || level?.startsWith('pg') || level?.startsWith('diploma') || level?.startsWith('p_g_diploma') || level?.startsWith('phd') || level?.startsWith('pd')) {
          const isCurrentCourse = studentDetails?.currentCourse?.id === edu.id
          fieldPrefix = isCurrentCourse ? 'currentCourse' : 'otherEducation'
        }

        if (!fieldPrefix) return

        // Check specific field names that exist in TPO config
        const specificFieldNames = [
          `${fieldPrefix}.markSheetUrl`,
          `${fieldPrefix}.board`,
          `${fieldPrefix}.marks`,
          `${fieldPrefix}.endYear`,
          `${fieldPrefix}.degree`,
          `${fieldPrefix}.department`,
          `${fieldPrefix}.collegeName`,
          `${fieldPrefix}.university`,
          `${fieldPrefix}.specialisation`,
          `${fieldPrefix}.city`,
          `${fieldPrefix}.state`
        ]

        specificFieldNames.forEach(fieldName => {
          const fieldConfig = fields[fieldName]
          
          if (!fieldConfig) return

          // Check if this field should be frozen
          const shouldFreeze = (fieldConfig.freezeAfterVerification || fieldConfig.freezeAfterApproval)
          
          if (shouldFreeze) {
            // Map the specific field name back to the actual education object property
            let actualFieldName = fieldName.replace(`${fieldPrefix}.`, '')
            
            // Handle special mappings
            if (actualFieldName === 'endYear') actualFieldName = 'endedOn'
            if (actualFieldName === 'collegeName') actualFieldName = 'institutionName'
            
            const fieldValue = edu[actualFieldName]
            
            // For markSheetUrl, freeze if it has a value with url
            if (actualFieldName === 'markSheetUrl' && fieldValue && fieldValue.url) {
              frozen[eduId][actualFieldName] = true
              frozen[eduId][fieldName] = true
            }
            // For other fields, freeze if they have values
            else if (fieldValue !== null && fieldValue !== undefined && fieldValue !== '') {
              frozen[eduId][actualFieldName] = true
              frozen[eduId][fieldName] = true
            }
          }
        })
      })

      setFrozenFields(frozen)
    } catch (e) {
      console.error('Failed to calculate education frozen fields:', e)
    }
  }

  calculateEducationFrozenFields()
}, [studentDetails, instituteName?.id])

useEffect(() => {
  const loadData = async () => {
    try {
      setLoadingResumes(true); 
      await fetchResumeData();
    } catch (error) {
      console.error('Error fetching resume data:', error);
    } finally {
      setLoadingResumes(false); 
    }
  };

  loadData();
}, [studentId, pendingData]);
  const handleResumeUpload = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const allowedTypes = ["pdf"];
  const fileExt = file.name.split(".").pop().toLowerCase();

  // INVALID FORMAT
  if (!allowedTypes.includes(fileExt)) {
    setResumeError("Please upload valid file format");

    event.target.value = ""; // <-- IMPORTANT FIX
    return;
  }
// ✅ VALIDATION 2: 5 MB LIMIT
  const MAX_SIZE = 5 * 1024 * 1024; // 5MB
  if (file.size > MAX_SIZE) {
    setResumeError("File size should not exceed 5 MB");
    return;
  }

  // ✅ VALIDATION 3: DUPLICATE NAME CHECK (case-insensitive)
  const isDuplicate = resumeFiles.some(
    (item) => item.name.toLowerCase() === file.name.toLowerCase()
  );

  if (isDuplicate) {
    setResumeError("A resume with the same file name already exists");
    return;
  }

  // MAX FILE LIMIT
  if (resumeFiles.length >= 5) {
    setResumeError("Max no. of files uploaded");

    event.target.value = ""; // <-- IMPORTANT FIX
    return;
  }

  setResumeError("");

  const newFile = {
    id: Date.now(),
    file,
    name: file.name,
    type: fileExt.toUpperCase(),
    uploadedOn: new Date().toLocaleDateString("en-GB"),
    url: URL.createObjectURL(file),
  };

  setResumeFiles(prev => [...prev, newFile]);

  event.target.value = ""; // <-- CRITICAL FIX (allows re-upload of same file)
};
const deleteResumeFile = async (id) => {
  // Create a copy of current files
  const updatedFiles = [...resumeFiles];
  const fileToDelete = updatedFiles.find(f => f.id === id);
  
  if (!fileToDelete) {
    console.warn("File not found for deletion:", id);
    return;
  }

  // Remove the file from local state
  const filteredFiles = updatedFiles.filter((item) => item.id !== id);
  setResumeFiles(filteredFiles);

  // Handle default resume ID update
  let newDefaultId = defaultResumeId;
  if (defaultResumeId === id) {
    newDefaultId = filteredFiles.length > 0 
      ? filteredFiles[filteredFiles.length - 1].id 
      : "PIL";
    setDefaultResumeId(newDefaultId);
  }

  // Prepare payload with remaining files
  const payload = {
    checkForApproval:true,
    instituteCampusId: instituteName?.id,
    resumes: filteredFiles.map((f) => {
      const raw = f._raw || {};
      const isSystem = raw.resumeType === "SYSTEM";

      return {
        id: raw.id || null,
        resumeName: f.name,
        resumeType: raw.resumeType || "UPLOADED",
        fileUrl: isSystem
          ? { url: "", type: "SYSTEM_GENERATED" }
          : raw.fileUrl || { url: f.url },
        isDefault: f.id === newDefaultId, // Use the new default ID
        fileSize: isSystem ? null : raw.fileSize || f.fileSize || null,
        fileFormat: raw.fileFormat || (f.name?.split(".").pop()?.toLowerCase() || null), 
      };
    }),
  };
 console.log("PAYLOAD:", payload);
  try {
    // Call API to update the backend
    await upsertStudentResume(payload);
    await fetchResumeData(); // Refresh the data
    await getPendingData();

    SuccessMessage("File removed successfully!");
  } catch (error) {
    console.error("Failed to delete file:", error);
    // Revert local state on error
    setResumeFiles(updatedFiles);
    setDefaultResumeId(defaultResumeId);
  }
};

const downloadResumeFile = (file) => {
  const url = file.url;   // dynamic URL
  const name = file.name; // dynamic file name (not required for opening)

  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";      // opens in new tab
  link.rel = "noopener noreferrer"; // safe practice

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  const ClickedObject = () => {
    object.current.scrollIntoView({ behavior: 'smooth' })
  }

  const ClickedEdu = () => {
    education.current.scrollIntoView({ behavior: 'smooth' })
  }
  const ClickedProject = () => {
    project.current.scrollIntoView({ behavior: 'smooth' })
  }
  const ClickedCourse = () => {
    course.current.scrollIntoView({ behavior: 'smooth' })
  }
  const ClickedAward = () => {
    award.current.scrollIntoView({ behavior: 'smooth' })
  }
  const ClickedWork = () => {
    workexp.current.scrollIntoView({ behavior: 'smooth' })
  }

  function calculateWorkExperience(experience) {
    let totalMonths = 0
    const currentDate = new Date()
    experience.forEach(job => {
      const [startMonth, startYear] = (job?.started_in || '').split('/')

      const startDate = new Date(startYear, startMonth)
      const endDate = job?.isCurrentlyWorking
        ? currentDate
        : new Date(...(job?.ended_in || '').split('/').reverse())
      const diffInMonths =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth())
      totalMonths += diffInMonths
    })
    if (totalMonths >= 12) {
      const years = Math.floor(totalMonths / 12)
      const months = totalMonths % 12
      return `${years} year${years > 1 ? 's' : ''} ${
        months > 0 ? `${months} month${months > 1 ? 's' : ''} ` : ''
      } `
    } else {
      return `${totalMonths} month${totalMonths > 1 ? 's' : ''}`
    }
  }

   useEffect(() => {
      fetchStudentFullData()
    }, [])
  
    const fetchStudentFullData = async () => {
      let result = await getStudentData()
      console.log(result,'result')
      setStudentFullData(result)
    }
     const downloadURI = async (file) => {
      // Create a blob from the URL to force download
      try {
        const response = await fetch(file.url)
        if (!response.ok) {
          throw new Error('Failed to download file')
        }
        const blob = await response.blob()
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = file.name
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      } catch (error) {
        console.error('Error downloading file:', error)
      }
    }
//     const handleDownloadResume = async () => {
//   if (!studentDetails) return;
// console.log("CHECK STUDENT DETAILS:", studentDetails);
// const payload = {
//   email: studentDetails?.admin?.email,
//   instName: studentDetails?.student?.instituteCampusName,
//   state: studentDetails?.currentCourse?.state,
//   city: studentDetails?.currentCourse?.city,
//   user: `${studentDetails?.admin?.firstName} ${studentDetails?.admin?.lastName}`,
//   studentIds: [[studentDetails?.currentCourse?.studentId]],
// };
//   console.log("DOWNLOAD LOG PAYLOAD:", payload);
//   // 🔹 1. Log in backend
//   await dispatch(logResumeDownload(payload));
//   // 🔹 2. Download resume
//   // if (studentFullData?.cvUrl?.url) {
//   //   downloadURI(studentFullData?.cvUrl);
//   // }
// };
const handleStudentResumeDownload = async () => {
  try {
    const payload = {
      email: studentDetails?.admin?.email,
      instName: studentDetails?.student?.instituteCampusName,
      state: studentDetails?.currentCourse?.state,
      city: studentDetails?.currentCourse?.city,
      user: `${studentDetails?.admin?.firstName} ${studentDetails?.admin?.lastName}`,
      studentIds: [[studentDetails?.currentCourse?.studentId]],
    };
    const response = await resumeBulkDownload(payload);
    const studentName = `${studentDetails?.admin?.firstName} ${studentDetails?.admin?.lastName}`;
    if (response?.data) {
      await singlePdf(response, studentName);
    }
  } catch (err) {
    console.error('Resume download failed:', err);
  }
};
useEffect(() => {
    getStudentData()
  }, [additionalDrawer,objectiveDrawer,educationDrawer,projectDrawer,internDrawer,courseDrawer,awardsDrawer,proofDrawer])


const mapApiResumesToUi = (backendResumes = []) =>
  backendResumes.map((r) => ({
    id: r.id,
    name: r.resumeName,
    type:
      r.resumeType === "SYSTEM"
        ? "SYSTEM"
        : "UPLOADED",
    url: r.fileUrl?.url || "",
    uploadedOn: new Date(r.createdAt).toLocaleDateString("en-GB"),
    isDefault: r.isDefault,
    fileFormat: r.fileFormat?.toLowerCase() || null,
    _raw: r,
  }));
//   const downloadDefaultResume = async(response,studentName,studentId)=>{
//     // const res = await studentRequest.get(`/students/${studentId}`)
//     // const cvUrlTYPE = res?.data?.data?.cvUrl?.type || 'pdf'
//     const blob = new Blob([response], { type: 'application/pdf' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `${studentName} resume.pdf`;
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//    return window.URL.revokeObjectURL(url);
// }
//   async () => {
//   // const defaultResume = resumeFiles.find(
//   //   (r) => r.id === defaultResumeId
//   // );
//   // if (!defaultResume || !defaultResume.url) {
//   //   ErrorMessage("Default resume not found");
//   //   return;
//   // }
// let response=  await handleDownloadResume();
//   downloadURI(defaultResume);
// };
const handleUploadDrawerSave = async (files, selectedId) => { 
  console.log(files,"preload")
  const resumesPayload = files.map(f => {
    const raw = f._raw || {};
    const isSystem = raw.resumeType === "SYSTEM";

    return {
      id: raw.id || null,
      resumeName: f.name,
      resumeType: raw.resumeType || "UPLOADED",
      fileUrl: isSystem 
        ? { url: "", type: "SYSTEM_GENERATED" } 
        : raw.fileUrl || { url: f.url },
      isDefault: f.id === selectedId,
      fileSize: isSystem 
        ? null 
        : raw.fileSize || f.file?.size || null,
      fileFormat: raw.fileFormat || (f.name?.split(".").pop()?.toLowerCase() || null),
    };
  });

  const payload = { resumes: resumesPayload,
    checkForApproval: true,
    instituteCampusId: instituteName?.id,    };
  console.log("PAYLOAD:", payload);
 await upsertStudentResume(payload);
 await fetchResumeData();
 await getPendingData();
};
const handleSetDefaultResume = async (selectedId) => {
  const payload = {
    resumes: resumeFiles.map((f) => {
      const raw = f._raw || {};
      const isSystem = raw.resumeType === "SYSTEM";

      return {
        id: raw.id || null,
        resumeName: f.name,
        resumeType: raw.resumeType || "UPLOADED",
        fileUrl: isSystem
          ? { url: "", type: "SYSTEM_GENERATED" }
          : raw.fileUrl || { url: f.url },
        isDefault: f.id === selectedId,
        fileSize: isSystem ? null : raw.fileSize || f.fileSize || null,
        fileFormat: raw.fileFormat || (f.name?.split(".").pop()?.toLowerCase() || null),
      };
    }),
  };

 console.log("PAYLOAD:", payload);

  await upsertStudentResume(payload);
  await fetchResumeData();
};

const mapPendingResumesToUi = (pendingResumes = []) =>
  pendingResumes.map(r => ({
    id: r._itemId,                 // temporary id for UI
    name: r.resumeName,
    type: r.resumeType,
    url: r.fileUrl?.url || "",
    uploadedOn: new Date().toLocaleDateString("en-GB"),
    isDefault: false,
    isPending: r._status === "PENDING", // ✅ MAIN FLAG
    fileFormat: r.fileFormat || r.resumeName?.split(".").pop()?.toLowerCase() || "pdf",
    _raw: r,
  }));

const fetchResumeData = async () => {
  const result = await getStudentResumeData(studentId);

  // ✅ approved
  const approvedUi = mapApiResumesToUi(result?.resumes || []);

  // ✅ pending
  const pendingUi = mapPendingResumesToUi(pendingData?.resumes || []);

  // ✅ merge
  setResumeFiles([...approvedUi, ...pendingUi]);

  // ✅ default only from approved
  const def = approvedUi.find(r => r.isDefault);
  setDefaultResumeId(def ? def.id : "PIL");
};
  return (
    <>
      {/* <PDFViewer
        style={{
          width: '100%',
          height: '100',
          justifyContent: 'center',
          border: '1px solid black',
        }}
      >
        <PdfDocument data={studentDetails} instituteName={instituteName} />
      </PDFViewer> */}
      <SectionWrapper column>
        <OuterDiv ref={ref}>
          <TopHeader row spaceBetween alignCenter>
            <TopHeading flexStart>My Resume</TopHeading>
  <Button.Primary
    height={'38px'}
    text={'Download Resume'}
    width={'180px'}
    onClick={handleStudentResumeDownload}
  />
{/* {studentFullData?.cvUrl?.url ? (
  <Button.Primary
    height={'38px'}
    text={'Download Resume'}
    width={'180px'}
    onClick={downloadDefaultResume}
  />
) : (
  studentDetails?.admin?.firstName && (
    <ResumeDownload 
      studentData={studentDetails}
      onBeforeDownload={handleDownloadResume} 
    />
  )
)} */}


            {/* <PDFDownloadLink
              document={
                <PdfDocument
                  data={studentDetails}
                  instituteName={instituteName}
                />
              }
              fileName="Resume.pdf"
            >
              {({ blob, url, loading, error }) => (
                <Button.Primary
                  text={loading ? 'Loading document' : 'Download Resume'}
                  width={'180px'}
                  loading={loading}
                />
              )}
            </PDFDownloadLink> */}
          </TopHeader>
          <RowwithPadding>
            <LeftCol span={16}>
              <HeaderFlexOne spaceBetween>
                <Flex>
                  <AvatarImage
                    background
                    src={studentDetails?.student?.profileUrl}
                    IconName={studentDetails?.admin?.firstName[0]}
                    size={90}
                    font={18}
                  />

                  <InfoSection column center>
                    <StudentName>
                      {studentDetails?.admin?.firstName}{' '}
                      {studentDetails?.admin?.lastName}
                    </StudentName>
                    <CollegeName>
                      <MailIcon /> {studentDetails?.admin?.email}
                    </CollegeName>
                    <CollegeName>
                      <CallIcon /> {studentDetails?.admin?.countryCode}-
                      {studentDetails?.admin?.phoneNumber}
                    </CollegeName>
                    {studentDetails?.student?.isExpCandidate && (
                      <CollegeName>
                        <OfferIcon className="iconStyle" />
                        {calculateWorkExperience(
                          studentDetails?.resume?.workExperience
                        )}
                      </CollegeName>
                    )}
                  </InfoSection>
                </Flex>
              </HeaderFlexOne>
              <SectionNavMenu
                mode="horizontal"
                defaultSelectedKeys={['Objective']}
              >
                <MenuItem key="Objective" onClick={ClickedObject}>
                  Objective
                </MenuItem>
                <MenuItem key="mail1" onClick={ClickedEdu}>
                  Education
                </MenuItem>
                <MenuItem key="Project" onClick={ClickedProject}>
                  Projects & Internships
                </MenuItem>
                <MenuItem key="Courses" onClick={ClickedCourse}>
                  Certification
                </MenuItem>
                <MenuItem key="Awards" onClick={ClickedAward}>
                  Awards
                </MenuItem>
                <MenuItem key="Work" onClick={ClickedWork}>
                  Work Experience
                </MenuItem>
              </SectionNavMenu>
              <Row ref={object}>
                <Col span={20}>
                  <MainHeading paddingTop="25px" marginBottom="10px">
                    Objective
                  </MainHeading>
                </Col>
                <Col span={4}>
                {JBIMS_INSITITUTE_CAMPUS_ID !== instituteName?.id && (
                  <GeneralEditIcon>
                    <Avatar
                      onClick={() => {
                        setObjectiveDrawer(true)
                      }}
                      src={<EditIcon className="iconStyle" />}
                    />
                  </GeneralEditIcon>
                )}
                </Col>
              </Row>

              <StyledP>
                <EditorContent
                  dangerouslySetInnerHTML={{
                    __html: studentDetails?.resume?.objective || '',
                  }}
                />
              </StyledP>
              <StyledDivider />
              <Row ref={education}>
                <Col span={20}>
                  <MainHeading>Educations</MainHeading>
                </Col>
                <Col span={4}>
                {JBIMS_INSITITUTE_CAMPUS_ID !== instituteName?.id && (
                  (() => {
                    // Check if any education item is frozen (has markSheetUrl frozen)
                    const hasFrozenEducation = studentDetails?.education?.some(edu => 
                      edu && edu.id && frozenFields && frozenFields[edu.id] && (
                        frozenFields[edu.id]?.markSheetUrl || 
                        frozenFields[edu.id]?.certifications ||
                        (edu.educationLevel === 'tenth' ? frozenFields['tenth.board'] : 
                         edu.educationLevel === 'twelfth' ? frozenFields['twelfth.board'] : 
                         frozenFields['otherEducation.board'])
                      )
                    )
                    
                    // Also check currentCourse if it exists
                    const hasFrozenCurrentCourse = studentDetails?.currentCourse && 
                      studentDetails.currentCourse.id && frozenFields && frozenFields[studentDetails.currentCourse.id] && (
                      frozenFields[studentDetails.currentCourse.id]?.markSheetUrl ||
                      frozenFields[studentDetails.currentCourse.id]?.certifications ||
                      frozenFields[studentDetails.currentCourse.id]?.university
                    )
                    
                    return (
                      <GeneralEditIcon>
                        <Avatar
                          onClick={() => {
                            setEducationDrawer(true)
                            dispatch(getStudentData(studentId))
                          }}
                          src={<EditIcon className="iconStyle" />}
                        />
                      </GeneralEditIcon>
                    )
                  })()
                )}
                </Col>
              </Row>
              <EducationSection
                studentDetails={studentDetails}
                instituteName={instituteName}
                pendingData={pendingData}
                deleteEducation={deleteEducation}
                frozenFields={frozenFields}
              />
              <StyledDivider />
              <Row ref={project}>
                <Col span={20}>
                  <MainHeading>Projects</MainHeading>
                </Col>
                <Col span={4}>
                  {JBIMS_INSITITUTE_CAMPUS_ID !== instituteName?.id && (
                    <GeneralEditIcon>
                      <Avatar
                        onClick={() => {
                          setProjectDrawer(true)
                        }}
                        src={<EditIcon className="iconStyle" />}
                      />
                    </GeneralEditIcon>
                  )}
                </Col>
              </Row>
              <SubFLex column gap="25px">
                <ProjectSection studentDetails={studentDetails} pendingData={pendingData} />
              </SubFLex>
              <StyledDivider />
              <Row>
                <Col span={20}>
                  <MainHeading>Internship</MainHeading>
                </Col>
                <Col span={4}>
                  {JBIMS_INSITITUTE_CAMPUS_ID !== instituteName?.id && (
                    <GeneralEditIcon>
                      <Avatar
                        onClick={() => {
                          setInternDrawer(true)
                        }}
                        src={<EditIcon className="iconStyle" />}
                      />
                    </GeneralEditIcon>
                  )}
                </Col>
              </Row>
              <SubFLex column gap="25px">
                <InternshipSection studentDetails={studentDetails} pendingData={pendingData} />
              </SubFLex>
              <StyledDivider />
              <Row ref={course}>
                <Col span={20}>
                  <MainHeading> Certification</MainHeading>
                </Col>
                <Col span={4}>
                  {JBIMS_INSITITUTE_CAMPUS_ID !== instituteName?.id && (
                    <GeneralEditIcon>
                      <Avatar
                        onClick={() => {
                          setCourseDrawer(true)
                        }}
                        src={<EditIcon className="iconStyle" />}
                      />
                    </GeneralEditIcon>
                  )}
                </Col>
              </Row>
              <SubFLex column gap="25px">
                <TrainingSection studentDetails={studentDetails} pendingData={pendingData} />
              </SubFLex>

              <StyledDivider />
              <Row ref={workexp}>
                <Col span={20}>
                  <MainHeading>Work Experience</MainHeading>
                </Col>
                <Col span={4}>
                  {JBIMS_INSITITUTE_CAMPUS_ID !== instituteName?.id && (
                    <GeneralEditIcon>
                      <Avatar
                        onClick={() => {
                          setWorkExperienceDrawer(true)
                        }}
                        src={<EditIcon className="iconStyle" />}
                      />
                    </GeneralEditIcon>
                  )}
                </Col>
              </Row>

              <SubFLex column gap="25px">
                <WorkExpSection
                  studentDetails={studentDetails}
                  promotionData={promotionData}
                  pendingData={pendingData}
                />
              </SubFLex>
              <StyledDivider />
              <Row ref={award}>
                <Col span={20}>
                  <MainHeading>Awards & Recognition </MainHeading>
                </Col>
                <Col span={4}>
                  {JBIMS_INSITITUTE_CAMPUS_ID !== instituteName?.id && (
                    <GeneralEditIcon>
                      <Avatar
                        onClick={() => {
                          setAwardsDrawer(true)
                        }}
                        src={<EditIcon className="iconStyle" />}
                      />
                    </GeneralEditIcon>
                  )}
                </Col>
              </Row>

              <SubFLex column gap="25px">
                <AwardsSection studentDetails={studentDetails} />
              </SubFLex>
            </LeftCol>
            <Col span={8}>
              <RightDiv>
                {!studentDetails?.student?.isExpCandidate && (
                  <>
                    <CurrentlyPursuing
                      studentDetails={studentDetails}
                      instituteName={instituteName}
                    />
                    <StyledDivider />
                  </>
                )}
                <Row>
                  <Col span={20}>
                    <MainHeading>Additional Information</MainHeading>
                  </Col>
                  <Col span={4}>
                    {JBIMS_INSITITUTE_CAMPUS_ID !== instituteName?.id && (
                      <GeneralEditIcon>
                        <Avatar
                          onClick={() => {
                            setAdditionalDrawer(true)
                          }}
                          src={<EditIcon className="iconStyle" />}
                        />
                      </GeneralEditIcon>
                    )}
                  </Col>
                </Row>
                <AdditionalInfo studentDetails={studentDetails} pendingData={pendingData} />
                <StyledDivider />
                <Row>
                  <Col span={20}>
                    <MainHeading>Social Media Links</MainHeading>
                  </Col>
                  <Col span={4}>
                    {JBIMS_INSITITUTE_CAMPUS_ID !== instituteName?.id && (
                      <GeneralEditIcon>
                        <Avatar
                          onClick={() => {
                            setSocialDrawer(true)
                          }}
                          src={<EditIcon className="iconStyle" />}
                        />
                      </GeneralEditIcon>
                    )}
                  </Col>
                </Row>
                <SocialMediaLinks studentDetails={studentDetails} />

                <StyledDivider />
                <Row>
  <Col span={20}>
    <MainHeading>Resume</MainHeading>
  </Col>
  <Col span={4}>
  <GeneralEditIcon>
      <SetDefaultPill onClick={() => setDefaultDrawer(true)}>
        Set Default
      </SetDefaultPill>
    </GeneralEditIcon>
</Col>
</Row>
<ResumeSection
  resumeFiles={resumeFiles}
  handleResumeUpload={handleResumeUpload}  // you can remove later if unused
  loading={loadingResumes}
  deleteResumeFile={deleteResumeFile}
  downloadResumeFile={downloadURI}
  systemResumeStudentData={studentDetails}
  resumeError={resumeError}
  defaultResumeId={defaultResumeId}          // 👈 pass default id
  onOpenUploadDrawer={() => setUploadDrawer(true)} // 👈 open new drawer
  studentUpdateAt={studentDetails?.updateAt}
  isResumeFrozen={isResumeFrozen}
/>


               {/* <StyledDivider />
                 <Row>
                  <Col span={20}>
                    <MainHeading>Documents</MainHeading>
                  </Col>
                  <Col span={4}>
                    <GeneralEditIcon>
                      <Avatar
                        onClick={() => {
                          setProofDrawer(true)
                        }}
                        src={<EditIcon className="iconStyle" />}
                      />
                    </GeneralEditIcon>
                  </Col>
                </Row>
                <Documents studentDetails={studentDetails} /> */}
              </RightDiv>
            </Col>
          </RowwithPadding>
        </OuterDiv>
      </SectionWrapper>

      {objectiveDrawer && (
        <ObjectiveDrawer
          drawerStatus={objectiveDrawer}
          setdrawerStatus={setObjectiveDrawer}
          studentFormData={studentDetails}
          updateStudentData={updateStudentData}
        />
      )}
      {educationDrawer && (
        <EducationalDetailDrawer
          drawerStatus={educationDrawer}
          setdrawerStatus={setEducationDrawer}
          studentFormData={studentDetails}
          pendingData={pendingData}
          updateStudentData={updateStudentData}
          getPendingData={getPendingData}
          deleteEducation={deleteEducation}
          deleteFile={deleteFile}
          instituteName={instituteName}
          countryList={countryList}
          stateList={stateList}
          getListOfCountries={getListOfCountries}
          getListOfState={getListOfState}
          getListOfCity={getListOfCity}
          getListOfSkills={getListOfSkills}
          getListOfAllCollegesCurCourse={getListOfAllCollegesCurCourse}
          degreeList={degreeList}
          listOfStudentSkills={listOfStudentSkills}
          searchAPI={searchAPI}
          frozenFields={frozenFields}
        />
      )}
      {projectDrawer && (
        <ProjectDrawer
          drawerStatus={projectDrawer}
          setdrawerStatus={setProjectDrawer}
          studentFormData={studentDetails}
          pendingData={pendingData}
          updateStudentData={updateStudentData}
          getPendingData={getPendingData}
          deleteFile={deleteFile}
          instituteName={instituteName}
          listOfStudentSkills={listOfStudentSkills}
          getListOfSkills={getListOfSkills}
        />
      )}
      {internDrawer && (
        <InternshipDrawer
          drawerStatus={internDrawer}
          setdrawerStatus={setInternDrawer}
          studentFormData={studentDetails}
          pendingData={pendingData}
          getPendingData={getPendingData}
          updateStudentData={updateStudentData}
          listOfStudentSkills={listOfStudentSkills}
          getListOfSkills={getListOfSkills}
        />
      )}
      {courseDrawer && (
        <CourseTrainingDrawer
          drawerStatus={courseDrawer}
          setdrawerStatus={setCourseDrawer}
          studentFormData={studentDetails}
          pendingData={pendingData}
          getPendingData={getPendingData}
          updateStudentData={updateStudentData}
          listOfStudentSkills={listOfStudentSkills}
          getListOfSkills={getListOfSkills}
        />
      )}
      {workExperienceDrawer && (
        <WorkExperienceDrawer
          drawerStatus={workExperienceDrawer}
          setdrawerStatus={setWorkExperienceDrawer}
          studentFormData={studentDetails}
          pendingData={pendingData}
          getPendingData={getPendingData}
          updateStudentData={updateStudentData}
          getFunctionsList={getFunctionsList}
          functionsList={functionsList}
          listOfStudentSkills={listOfStudentSkills}
          getListOfSkills={getListOfSkills}
        />
      )}
      {awardsDrawer && (
        <AwardsDrawer
          drawerStatus={awardsDrawer}
          setdrawerStatus={setAwardsDrawer}
          updateStudentData={updateStudentData}
          studentFormData={studentDetails}
          getListOfSkills={getListOfSkills}
        />
      )}
      {additionalDrawer && (
        <AdditionDrawer
          drawerStatus={additionalDrawer}
          setdrawerStatus={setAdditionalDrawer}
          updateStudentData={updateStudentData}
          countryList={countryList}
          getListOfCountries={getListOfCountries}
          getListOfState={getListOfState}
          getListOfCity={getListOfCity}
          getCities={getCities}
          studentFormData={studentDetails}
          pendingData={pendingData}
          getPendingData={getPendingData}
        />
      )}
      {socialDrawer && (
        <SocialMediaDrawer
          drawerStatus={socialDrawer}
          setdrawerStatus={setSocialDrawer}
          updateStudentData={updateStudentData}
          studentFormData={studentDetails}
        />
      )}

      {proofDrawer && (
        <ProofDocuments
          drawerStatus={proofDrawer}
          setdrawerStatus={setProofDrawer}
          updateStudentData={updateStudentData}
          studentFormData={studentDetails}
        />
      )}

      {defaultDrawer && (
  <DefaultResumeDrawer
    drawerStatus={defaultDrawer}
    setDrawerStatus={setDefaultDrawer}
    resumeFiles={resumeFiles}   // user uploads
    pilResume={true}            // show PIL block
    defaultId={defaultResumeId} // pre-select current default
    onDownload={downloadURI}
    onSetDefault={(id) => handleSetDefaultResume(id)}
    getStudentResumeData={getStudentResumeData}
    studentId={studentId}
    onDeleteResume={deleteResumeFile}
    studentUpdateAt={studentDetails?.updateAt}
    getPendingData={getPendingData}   
    pendingData={pendingData}
    isResumeFrozen={isResumeFrozen} 
  />
)}
{uploadDrawer && (
  <UploadResumeDrawer
  drawerStatus={uploadDrawer}
  setDrawerStatus={setUploadDrawer}
  resumeFiles={resumeFiles}
  defaultId={defaultResumeId}
  onSave={handleUploadDrawerSave}
  getStudentResumeData={getStudentResumeData}
  getPendingData={getPendingData}   
  pendingData={pendingData} 
  studentId={studentId}
  studentUpdateAt={studentDetails?.updateAt}
  studentDetails={studentDetails}
  isResumeFrozen={isResumeFrozen}
/>
)}


    </>
  )
}
export default Resume
